/*! All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://github.com/Esri/calcite-design-system/blob/dev/LICENSE.md for details.
v3.3.3 */
import { makeT9nController } from "@arcgis/lumina/controllers";
import { g as getAssetPath } from "./runtime.js";
const useT9n = makeT9nController(getAssetPath);
export {
  useT9n as u
};
